import React from 'react'

import { Item } from 'modules/processes/domain'
import { useFiles } from 'modules/processes/hooks/useFiles'

import BaseList, { FilesProps } from '../base'

export type FileUpdates = {
  filesToAdd: File[]
  filesToRemove: Set<number>
}

type Props = {
  item?: Item
  files?: FilesProps
  onFileUpdates: (fileUpdates: FileUpdates) => void
}

const FilesListWithFiles = ({ item, onFileUpdates }: Props) => {
  const files = useFiles(item?.configurationId ?? undefined)

  return <BaseList files={files} onFileUpdates={onFileUpdates} />
}

const FilesList = ({ item, onFileUpdates, files }: Props) => {
  if (files) {
    return <BaseList files={files} onFileUpdates={onFileUpdates} />
  }

  return <FilesListWithFiles item={item} onFileUpdates={onFileUpdates} />
}

export default FilesList
